import { IProductData } from 'interfaces/IProductData';
import { apiService } from 'shared/services';
import md5 from 'md5';
import { CACHED_MOUNT } from 'settings';
import { enProductType } from 'enums/enProductType';

export class CacheService {

  private saved = false;

  setCache(key: string, data: IProductData): void {

    if (
      this.saved
      || data.config.productType === enProductType.TICKET
      || data.isCached
      || data.coupon
      || data.quantity != 1
      || data.config.isOneClick
    ) {
      return;
    }

    this.saved = true;

    (data.hash as any) = md5(JSON.stringify(data));

    const cachedMount = CACHED_MOUNT;

    if (cachedMount && data.hash === cachedMount.hash) {
      return;
    }

    data = JSON.parse(JSON.stringify(data));

    (data.transactionKey as any) = null;

    apiService.post(`/cache/check/${key}`, data, {}, { local: true }).subscribe();

  }

}

// tslint:disable-next-line:variable-name
export const CacheServiceFactory = () => new CacheService();

export const cacheService = CacheServiceFactory();


// WEBPACK FOOTER //
// ./src/services/CacheService.ts